import React from 'react';
import { VideoPlayer as VideoPlayerComponent } from './VideoPlayer';
import { VideoPlayerStatic } from './Static';
import type { VideoPlayerProps } from './VideoPlayer';
import { PlayerContent, type PlayerContentProps } from './PlayerContent';

type VideoPlayerWithActionButtonProps = Omit<VideoPlayerProps & PlayerContentProps, 'progressInterval'>;

export function VideoPlayerWithActionButton(props: VideoPlayerWithActionButtonProps): JSX.Element {
	const { onActionClick, actionButton, actionLabel, ...videoPlayerProps } = props;

	return (
		<VideoPlayerComponent {...videoPlayerProps} showCloseButton={false} showMinimize={false}>
			<VideoPlayerStatic>
				<PlayerContent
					src={videoPlayerProps.src ?? ''}
					poster={videoPlayerProps.poster}
					thumbnail={videoPlayerProps.thumbnail}
					onActionClick={onActionClick}
					actionButton={actionButton}
					actionLabel={actionLabel}
					playIconSize={videoPlayerProps.playIconSize}
					withOverlay
					lazyMountVideo
					onPlayClick={videoPlayerProps.onPlayClick}
				/>
			</VideoPlayerStatic>
		</VideoPlayerComponent>
	);
}
